export function TeamPage() {
  return (
    <div className="px-6 py-6 sm:px-10 lg:px-16">
      <div className="mb-6">
        <h1 className="text-headline text-gray-900 dark:text-white font-display">Team</h1>
        <p className="text-body text-gray-500 dark:text-gray-400 mt-2">Team workload and sprint health</p>
      </div>
      <div className="bg-white dark:bg-bg-surface border border-gray-100 dark:border-white/[0.06] rounded-xl p-12 text-center">
        <p className="text-gray-400 dark:text-gray-500 text-body font-medium">Coming soon</p>
      </div>
    </div>
  );
}
